module.exports = tribe.common.data.forms;